import React, { createContext, useContext, useEffect, useState } from "react";
import { T } from "./data";

const SUPPORTED = ["it", "en", "fr", "es", "de"];
const LangContext = createContext({ lang: "it", setLang: () => {}, t: T.it });

export const LangProvider = ({ children }) => {
    const [lang, setLang] = useState(() => {
        try {
            const stored = localStorage.getItem("tada_lang");
            return SUPPORTED.includes(stored) ? stored : "it";
        } catch {
            return "it";
        }
    });
    useEffect(() => {
        try { localStorage.setItem("tada_lang", lang); } catch (_e) { /* ignore */ }
        document.documentElement.lang = lang;
        // Ensure Google Translate stays disabled even if language attribute changes
        document.documentElement.setAttribute("translate", "no");
    }, [lang]);
    // Fallback to Italian if a translation key is missing for the current lang
    const t = { ...T.it, ...(T[lang] || {}) };
    // pick({it, en, fr, es, de}) — returns the string for the active lang with graceful fallback
    // to en (if available) then it. Useful for inline strings not in the T dict.
    const pick = (dict) => (dict && (dict[lang] || dict.en || dict.it)) || "";
    return (
        <LangContext.Provider value={{ lang, setLang, t, pick }}>
            {children}
        </LangContext.Provider>
    );
};

export const useLang = () => useContext(LangContext);
